export const headers = [
  { content: "Feedback type", isSorting: true },
  { content: "Trigger points", isSorting: true },
  { content: "Nr of questions", isSorting: true },
  { content: "" }
];
